import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import From from 'react-bootstrap/Form';
import { useState } from 'react';

export const RateQuoteModal = ({ formik, show, handleClose, data }) => {
    const [selectedServiceType, setSelectedServiceType] = useState('');
    const isMps = formik.values.mpsPackages.length > 0;

    const closeModal = () => {
        setSelectedServiceType('');
        handleClose();
    }

    const handleSubmit = () => {
        formik.setFieldValue('serviceType', selectedServiceType);
        closeModal();
    }

    return (
        <Modal show={show} onHide={closeModal} backdrop='static'>
            <Modal.Header closeButton>Transit times</Modal.Header>
            <Modal.Body>
                <fieldset>
                    <legend>Transit Times (Rates are in USD)</legend>
                    {isMps && <h5>{formik.values.mpsPackages.length} packages</h5>}
                    <Table>
                        <thead>
                            <tr>
                                <th>Select</th>
                                <th>Service</th>
                                <th>Deliver By</th>
                                <th>Your Rate</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((i) => (
                                <tr key={i.service}>
                                    <td>
                                        <From.Check
                                            type='radio'
                                            name='serviceType'
                                            onChange={() => setSelectedServiceType(i.service)}
                                            checked={isMps ? formik.values.serviceType === i.service : selectedServiceType === i.service}
                                            disabled={isMps}
                                        />
                                    </td>
                                    <td>{i.serviceDisplay}</td>
                                    <td>{i.deliverBy ? `${i.deliverBy.dayOfWeek} ${new Date(i.deliverBy.dayFormat).toLocaleString('en-US')}` : 'Delivery date unavailable'}</td>
                                    <td>{'$' + i.yourRate}</td>
                                </tr>
                            ))
                            }
                        </tbody>
                    </Table>
                </fieldset>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={!selectedServiceType}
                    onClick={handleSubmit}
                    className='purple-btn'
                >
                    Ok
                </Button>
                <Button variant='secondary' onClick={closeModal}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}